module.exports = __webpack_public_path__ + "img/sp_logo.cedc8921.png";